export const GET = 'GET';
export const GET_SUCCEEDED = 'GET_SUCCEEDED';
export const GET_FAILED = 'GET_FAILED';

export const UPDATE_MAIL = 'UPDATE_MAIL';
export const UPDATE_MAIL_SUCCEEDED = 'UPDATE_MAIL_SUCCEEDED';
export const UPDATE_MAIL_FAILED = 'UPDATE_MAIL_FAILED';

export const SET = 'SET';
